/**
 * The jobs coming back from the call to api-v1 have a different shape than the jobs coming back from api-v2.  There are times
 * when we want to get the api-v1 job out of the collection.  This utility allows us to get that job on user action rather than the
 * initial approach of looping through all return sets to build the ultimate job object which was hindering performance
 * @param {number} jobId
 * @param {Array<object>} v1JobsArray - Array of v1 job objects
 */
export const findV1Job = (jobId, v1JobsArray) => {
  return v1JobsArray.find( v1Job => v1Job.id === jobId );
}

/**
 * A utility method for finding an array of v1Jobs with an array of v2 jobs
 * @param {Array<object>} v2JobsArray - Array of v2 job objects
 * @param {Array<object>} v1JobsArray - Array of v1 job objects
 */
export const findV1Jobs = (v2JobsArray, v1JobsArray) => {
  const v1Jobs = [];
  v2JobsArray?.forEach(v2Job => {
    const v1Job = findV1Job(v2Job.jobId, v1JobsArray)
    if(v1Job) {
      v1Jobs.push(v1Job);
    }
  });
  return v1Jobs;
}